// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__25gz-","container":"styles_container__1h1Mi","title":"styles_title__2QlWv","wrapper":"styles_wrapper__1b5Ah","answer":"styles_answer__jLMV_"};